import React from 'react';
import { motion } from 'framer-motion';
import { Search, TrendingUp } from 'lucide-react';
import ProductCard from './ProductCard';
import '../Products.css';

const ProductGrid = ({ products, viewMode = 'grid', liveRates = [] }) => {
  if (products.length === 0) {
    return (
      <motion.div
        className="empty-state"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ type: 'spring', stiffness: 300, damping: 30 }}
      >
        <motion.div
          animate={{
            rotate: [0, -10, 10, -10, 0],
            scale: [1, 1.1, 1]
          }}
          transition={{ duration: 2, repeat: Infinity }}
        >
          <Search size={64} className="empty-icon" />
        </motion.div>
        <h3 className="empty-title">No products found</h3>
        <p className="empty-description">
          Try adjusting your filters or search term
        </p>
      </motion.div>
    );
  }

  // Get live silver rate for display
  const silverRate = liveRates.find(
    rate => rate.metal === 'Silver' || rate.name?.toLowerCase().includes('silver')
  );

  return (
    <div className="product-grid-container">
      {silverRate && (
        <div className="live-rate-banner">
          <TrendingUp size={16} className="live-icon" />
          <span className="live-text">Live Silver Rate: </span>
          <span className={`live-price ${silverRate.change >= 0 ? 'price-up' : 'price-down'}`}>
            ₹{silverRate.price.toLocaleString()}
          </span>
          <span className="live-unit">per {silverRate.unit || 'kg'}</span>
          <span className={`live-change ${silverRate.change >= 0 ? 'positive' : 'negative'}`}>
            {silverRate.change >= 0 ? '▲' : '▼'} {Math.abs(silverRate.change).toFixed(2)}%
          </span>
        </div>
      )}

      <div className={`product-grid ${viewMode === 'list' ? 'list-view' : ''}`}>
        {products.map((product, index) => (
          <ProductCard
            key={product.id}
            product={product}
            index={index}
            silverRate={silverRate}
          />
        ))}
      </div>
    </div>
  );
};

export default ProductGrid;